type ObserveCallback = () => void;

const observerCallbacks = new WeakMap<Element, ObserveCallback>();
let sharedObserver: IntersectionObserver | null = null;

function getSharedObserver(rootMargin: string) {
  if (typeof IntersectionObserver === 'undefined') {
    return null;
  }

  if (!sharedObserver) {
    sharedObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          const callback = observerCallbacks.get(entry.target);
          if (callback) {
            callback();
            observerCallbacks.delete(entry.target);
            sharedObserver?.unobserve(entry.target);
          }
        });
      },
      { rootMargin, threshold: 0 },
    );
  }

  return sharedObserver;
}

export function observeWhenVisible(
  element: HTMLElement,
  callback: ObserveCallback,
  rootMargin = '200px 0px',
) {
  const observer = getSharedObserver(rootMargin);
  if (!observer) {
    callback();
    return () => undefined;
  }

  observerCallbacks.set(element, callback);
  observer.observe(element);

  return () => {
    observerCallbacks.delete(element);
    observer.unobserve(element);
  };
}
